export default "__VITE_ASSET__764a4a2b__"